// ============================================================
// DuckDB WASM Database
// MiningSurveyWebGIS
// ============================================================

import * as duckdb from "@duckdb/duckdb-wasm";

let db = null;
let conn = null;

let initialized = false;
let initializingPromise = null;


// ============================================================
// Initialize DuckDB
// ============================================================

export async function initCADDatabase() {

    // --------------------------------------------------------
    // Sudah siap
    // --------------------------------------------------------

    if (initialized && db && conn) {

        console.log("[CAD] DuckDB already READY.");

        return {
            db,
            conn
        };
    }


    // --------------------------------------------------------
    // Sedang initialization
    // --------------------------------------------------------

    if (initializingPromise) {

        console.log(
            "[CAD] DuckDB initialization already running..."
        );

        return initializingPromise;
    }


    // --------------------------------------------------------
    // Start initialization
    // --------------------------------------------------------

    initializingPromise = (async () => {

        try {

            console.log(
                "[CAD] ========================================"
            );

            console.log(
                "[CAD] Initializing DuckDB-WASM..."
            );


            /// ==================================================
            // Local DuckDB bundle
            // ==================================================

            const bundle = {
                mainModule: "/duckdb/duckdb-eh.wasm",
                mainWorker: "/duckdb/duckdb-browser-eh.worker.js",
                pthreadWorker: null
            };

            console.log(
                "[CAD] Using local DuckDB bundle:"
            );

            console.log(
                "[CAD] Worker:",
                bundle.mainWorker
            );

            console.log(
                "[CAD] WASM:",
                bundle.mainModule
            );


            // ==================================================
            // Worker
            // ==================================================

            const worker =
                new Worker(
                    bundle.mainWorker
                );


            // ==================================================
            // DuckDB
            // ==================================================

            db =
                new duckdb.AsyncDuckDB(
                    new duckdb.ConsoleLogger(),
                    worker
                );


            await db.instantiate(
                bundle.mainModule,
                bundle.pthreadWorker
            );


            console.log(
                "[CAD] DuckDB WASM instantiated."
            );


            // ==================================================
            // Connection
            // ==================================================

            conn =
                await db.connect();


            console.log(
                "[CAD] DuckDB connection created."
            );


            // ==================================================
            // Spatial extension
            // ==================================================

            console.log(
                "[CAD] Loading spatial extension..."
            );


            //await conn.query(
            //    "INSTALL spatial;"
            //);


            await conn.query(
                "LOAD spatial;"
            );


            console.log(
                "[CAD] Spatial extension loaded."
            );


            // ==================================================
            // Verify
            // ==================================================

            await conn.query(
                "SELECT ST_Point(0, 0);"
            );


            console.log(
                "[CAD] Spatial verification OK."
            );


            // ==================================================
            // READY
            // ==================================================

            initialized = true;


            console.log(
                "[CAD] ========================================"
            );

            console.log(
                "[CAD] DUCKDB READY"
            );

            console.log(
                "[CAD] ========================================"
            );


            return {
                db,
                conn
            };

        } catch (error) {

            console.error(
                "[CAD] DuckDB initialization FAILED:",
                error
            );


            initialized = false;
            db = null;
            conn = null;

            throw error;

        } finally {

            initializingPromise = null;

        }

    })();


    return initializingPromise;
}


// ============================================================
// Ready Status
// ============================================================

export function isCADDatabaseReady() {

    return (
        initialized === true &&
        db !== null &&
        conn !== null
    );
}


// ============================================================
// Get Database
// ============================================================

export function getCADDatabase() {

    if (!isCADDatabaseReady()) {

        throw new Error(
            "DuckDB is not initialized."
        );
    }

    return {
        db,
        conn
    };
}